/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ButtonVisitChoice/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.module.css"
import "DesignSystem/Fonts/Inter-400.module.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ButtonVisitChoice({
  children,
  viewPath = "/DesignSystem/ButtonVisitChoice",
  alignSelf = "auto",
  borderBottomLeftRadius = 5,
  borderBottomRightRadius = 5,
  borderColor = "#e5e5e5",
  borderTopLeftRadius = 5,
  borderTopRightRadius = 5,
  borderLeftWidth = 1,
  borderRightWidth = 1,
  marginLeft = 0,
  marginTop = 0,
  marginRight = 0,
  onClick,
  width = 0,
  backgroundColorHovered,
  borderColorHovered,
  isSelected,
  backgroundColorSelected,
  borderColorSelected = "#0093c9",
  color = "#323232",
  text = "label",
  colorHovered,
  colorSelected = "#ffffff"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
let dtColorsGreen700alpha5 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.5'
        })
let dtColorsGreen700alpha83 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.700alpha.83'
        })
let backgroundColorHoveredOrdtColorsGreen700alpha5 = backgroundColorHovered ?? dtColorsGreen700alpha5
let backgroundColorSelectedOrdtColorsGreen700alpha83 = backgroundColorSelected ?? dtColorsGreen700alpha83
let borderColorHoveredOrdtColorsGreen700alpha83 = borderColorHovered ?? dtColorsGreen700alpha83
let colorHoveredOrdtColorsGreen700alpha83 = colorHovered ?? dtColorsGreen700alpha83
  return (<React.Fragment
>
<button
  data-testid="ButtonVisitChoice.Horizontal"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--as-1-Z2kMpb8': alignSelf,'--bblr-3-Z2kMpb8': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z2kMpb8': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-6-Z2kMpb8': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-7-Z2kMpb8': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--blw-8-Z2kMpb8': typeof borderLeftWidth === 'number' ? `${borderLeftWidth}px` : borderLeftWidth,'--brw-9-Z2kMpb8': typeof borderRightWidth === 'number' ? `${borderRightWidth}px` : borderRightWidth,'--ml-10-Z2kMpb8': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mt-11-Z2kMpb8': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mr-12-Z2kMpb8': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--w-13-Z2kMpb8': typeof width === 'number' ? `${width}px` : width,'--bc-2-Z2kMpb8': isSelected ? backgroundColorSelectedOrdtColorsGreen700alpha83 : isHovered ? backgroundColorHoveredOrdtColorsGreen700alpha5 : "#ffffff",'--bc-5-Z2kMpb8': isSelected ? borderColorSelected : isHovered ? borderColorHoveredOrdtColorsGreen700alpha83 : borderColor}}
 className={`views-block ${styles.Horizontal}`}
>
<span
  data-testid="ButtonVisitChoice.Text"
  data-view-path={viewPath}
 style={{'--c-14-Z2kMpb8': isSelected ? colorSelected : isHovered ? colorHoveredOrdtColorsGreen700alpha83 : color}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}